import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImportTray = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 16V6m0 0L8.5 9.5M12 6l3.5 3.5",
		stroke: "currentColor",
		strokeWidth: 1.8,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5 16v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2",
		stroke: "currentColor",
		strokeWidth: 1.8,
		strokeLinecap: "round"
	})]
});
export default SvgImportTray;
